
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_936Ga8bvuYbYZPVSTf1GY66dIq4W8fwQFeJ8ypEZE9W28Meta } from "/codebuild/output/src380848875/src/compass-v2/packages/frontend/pages/[...slug].vue?macro=true";
import { default as component_45stub6IjtSZdZazoafztJhz95OiIK5NeQLViRs2A27IIzbk0Meta } from "/codebuild/output/src380848875/src/compass-v2/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub6IjtSZdZazoafztJhz95OiIK5NeQLViRs2A27IIzbk0 } from "/codebuild/output/src380848875/src/compass-v2/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src380848875/src/compass-v2/packages/frontend/pages/[...slug].vue")
  },
  {
    name: component_45stub6IjtSZdZazoafztJhz95OiIK5NeQLViRs2A27IIzbk0Meta?.name,
    path: "/index",
    component: component_45stub6IjtSZdZazoafztJhz95OiIK5NeQLViRs2A27IIzbk0
  }
]